<button id="close-features" type="button" class="button-close" (click)="onCancel()">
    <span class="icon icon-close white"></span>
</button>
<div class="dialog-modal-body text-center" style="min-height: 420px; padding: 0; position: relative;">
    <kendo-scrollview
        #whatsNew
        [data]="features()"
        width="100%"
        height="420px"
        class="k-scrollview--whatsnew"
        [animate]="true"
        [arrows]="false"
        [pageable]="hasMultipleFeatures()"
        [endless]="false"
        (itemChanged)="onItemChanged($event)">
        <ng-template let-item="item">
            <div class="feature-container">
                <div class="feature-container__col feature-container__col--left" [style.background]="item.gradientBackground">
                    <div class="flex direction-column gap-16">
                        @if (!!item.tag) {
                            <span
                                class="feature-container__tag"
                                [textContent]="item.tag"
                                [style.background-color]="item.tagSettings?.backColor"
                                [style.border-radius]="item.tagSettings?.radius"
                                [style.color]="item.tagSettings?.color"
                                [style.font-weight]="item.tagSettings?.fontWeight"
                                [style.letter-spacing]="item.tagSettings?.letterSpacing"
                                [style.padding]="item.tagSettings?.padding"></span>
                        }
                        <span class="feature-container__title" [textContent]="item.featureTitle"></span>
                    </div>
                    <span class="feature-container__description" [innerHTML]="item.featureDescription"></span>

                    <div class="flex gap-12 align-items-center mt-auto">
                        @if (item.hasSecondaryCta) {
                            <button
                                type="button"
                                class="button button--small {{ item.secondaryCtaClasses }}"
                                (click)="onSecondaryCtaClick(item.secondaryCtaAction)">
                                <span class="button__label" [textContent]="item.secondaryCtaText"></span>
                                @if (item.secondaryCtaIcon) {
                                    <span class="button__icon {{ item.secondaryCtaIcon }}"></span>
                                }
                            </button>
                        }
                        @if (item.url) {
                            <a
                                [href]="item.url"
                                class="button feature-container__button {{ item.ctaClasses }}"
                                [textContent]="item.featureTextButton"
                                target="_blank"></a>
                        }
                    </div>
                </div>
                <div class="feature-container__col feature-container__col--bg" [style.background-image]="item.backgroundImageUrl"></div>
            </div>
        </ng-template>
    </kendo-scrollview>
    @if (hasMultipleFeatures()) {
        <kendo-progressbar class="feature-container__progress" [animation]="progressAnimation()" [value]="progressValue()" [label]="{visible: false}">
        </kendo-progressbar>
    }
</div>
<div class="modal-footer flex justify-end align-items-center" style="min-height: 84px;">
    <button
        id="confirmation-modal-cancel-button"
        class="button"
        [class.button--secondary]="isLastSlide()"
        (click)="isLastSlide() ? onCancel() : nextSlide(whatsNew)">
        <span class="button__label" [textContent]="actionBtnText()"></span>
    </button>
</div>
